// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/VendasKpi_EvolucaoDiariaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/vendas_kpi/evolucao_diaria.
 *
 * Returns one VendasKpi_EvolucaoDiariaPontoRow per day, ordered ascending.
 */
import type { VendasKpi_EvolucaoDiariaPontoRow } from './VendasKpi_EvolucaoDiariaPontoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface VendasKpi_EvolucaoDiariaResponseDados {
pontos: VendasKpi_EvolucaoDiariaPontoRow[]
}

export type VendasKpi_EvolucaoDiariaResponse = ApiResponse<VendasKpi_EvolucaoDiariaResponseDados>;

registerResponseContract('VendasKpi_EvolucaoDiariaResponse', {
  pontos: {
    type: 'array',
    required: true,
    items: {
      data:              { type: 'string',  required: true },
      itens_recebidos:   { type: 'number',  required: false },
      vendas_realizadas: { type: 'number',  required: false },
    },
  },
})
